import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import MediaQuery from 'react-responsive';
import Slider from "react-slick";
import { withRouter } from "react-router-dom";

import axios from '../../../services/axios-service';
import * as actions from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import Profile from '../CandidateProfile/Profile';
import CandidateCard from '../../../components/Client/CandidateCard/CandidateCard';
import './talentPool.css';
import showMoreBtn from '../../../assets/images/showmore-arrow.svg';
import Loader from '../../../components/UI/Loader/Loader';
import MainJobTitle from '../../../components/Client/MainJobTitle/MainJobTitle'; 
import Button from '../../../components/UI/Button/Button';
import CsvIcon from '../../../assets/images/csv-file-format.svg';
import { scoringCriteria } from '../../../shared/constants';
// import ProgreesNotification from '../../../components/UI/ProgreesNotification/ProgreesNotification';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Talent pool list section
* @version 1.0.1
* @author Jamshith ,Lakshmikanth,Praveen,Amrutha
*/
class TalentPool extends Component {

  state = {
    itemsToShow:10,
    expanded: false,
    loading:true,
    notificationClose: false,
    interviewExists: this.props.interviewExists?this.props.interviewExists:null,
    showNotification: null,
    viewClicked: false,
  };

  /**
  * @desc redux call to get  candidate list  according to jobId on loading the page.
  * @param null
  * @return null
  */
  componentDidMount() {
    window.scrollTo(0,0);
    if(localStorage.getItem('jobTitleId') && localStorage.getItem('jobTitleId')!== "" && localStorage.getItem('jobTitleId')!== "null") {
      this.handleJobSelected(localStorage.getItem('jobTitleId'));
      this.props.onGetTalentPool(this.props.jobTitleId,this.props.user); 
 
      if(this.props.activeCandidateId && this.props.activeCandidateId !== null && this.props.activeCandidateId !== "") {
        this.props.onGetProfileDetails(this.props.activeCandidateId, this.props.jobTitleId,true,this.props.user);
      }    
    } else if(this.props.jobTitleId && this.props.jobTitleId !== null) {
      this.props.onGetTalentPool(this.props.jobTitleId,this.props.user);
    } 
          
    if(this.props.location.state && this.props.location.state.candidateId && (this.props.location.state.candidateId !== this.props.activeCandidateId)) {
      this.handleCandidateView(this.props.location.state.candidateId,this.props.jobTitleId);
    }

  }

  /**
  * @desc 
  * @param null
  * @return null
  */
  showModelCheck = () => {
    if(this.props.pool.length > 0) {
      const nullValue = this.props.pool.filter(cand => cand.candidate_status === "PENDING" );
      if(this.state.showModal==false && nullValue.length == 0 ) {
        this.setState({showModal : true})
      }
    }
  }
  /**
  * @desc loader added
  * @param prevProps, prevState
  * @return null
  */
  componentWillUpdate(prevProps, prevState) {
    if(this.props.jobTitleId !== prevProps.jobTitleId) {
    this.setState({loading: true});
    }
   }
  /**
  * @desc decides whether component should update according to the given condition
  * @param prevProps, prevState
  * @return null
  */
  shouldComponentUpdate(prevProps, prevState) {
    const currentCandidateIndex = this.props.pool.findIndex(cand => cand.candidate_id === this.props.activeCandidateId);
    return ( (this.props.pool.length > 0 && prevProps.pool[currentCandidateIndex] && prevProps.pool[currentCandidateIndex].candidate_status !== this.props.pool[currentCandidateIndex].candidate_status) || (prevProps.activeCandidateId !== this.props.activeCandidateId) || (this.state !== prevState) || (this.props.jobTitleId !== prevProps.jobTitleId) || (this.props.pool !== prevProps.pool));  
  }  
  /**
  * @desc fetches the candidate list on update
  * @param prevProps, prevState
  * @return null
  */
  componentDidUpdate(prevProps, prevState) {

    if(this.props.jobs !== prevProps.jobs && localStorage.getItem('jobTitleId') && localStorage.getItem('jobTitleId')!== "" && localStorage.getItem('jobTitleId')!== "null") {
      this.handleJobSelected(localStorage.getItem('jobTitleId'));
      this.props.onGetTalentPool(this.props.jobTitleId,this.props.user); 
      if(this.props.activeCandidateId && this.props.activeCandidateId !== null && this.props.activeCandidateId !== "") {
        this.props.onGetProfileDetails(this.props.activeCandidateId, this.props.jobTitleId,true,this.props.user);
      }   
      
    } else if(this.props.jobTitleId !== prevProps.jobTitleId && this.props.jobTitleId !== null) {
      this.props.onGetTalentPool(this.props.jobTitleId,this.props.user); 
    }

    if(this.props.pool !== prevProps.pool) {
      setTimeout(() => this.setState({loading: false}), 2000);
      if(this.props.pool.length > 0){
        if(this.props.pool[0].interview_exists === 'no'){
          if(this.props.pool.filter((candidate) => candidate.candidate_status === "PROGRESS").length > 0) {
            localStorage.setItem('showNotification', true);
            this.setState({showNotification: true});
          }else{
            localStorage.setItem('showNotification', false);
            this.setState({showNotification: false});
          }
        }else{
          localStorage.setItem('showNotification', false);
          this.setState({showNotification: false});
        }
      }
    } 

    if (this.props.activeCandidateId > 0 && !foundInPool(this.props.activeCandidateId, this.props.pool)&& this.props.pool[0].candidate_id!==undefined ) {
      this.props.onViewCandidate(this.props.pool[0].candidate_id,this.props.jobTitleId);
    }

    if((this.props.jobTitleId === prevProps.jobTitleId && this.props.jobTitleId !== null) && 
      this.props.activeCandidateId !== prevProps.activeCandidateId && 
      foundInPool(prevProps.activeCandidateId, this.props.pool) && 
      this.props.pool.find((candidate) => candidate.candidate_id === prevProps.activeCandidateId && candidate.review_status === "SENT" )) {
        this.props.onGetTalentPool(this.props.jobTitleId,this.props.user);
    }

  }
  /**
  * @desc shows/hides additional candidates list 
  * @param candidatesData - candidate pool list
  * @return null
  */
  showMore(candidatesData) {
    let listLength = candidatesData.length;
    let itemsToShow = this.state.itemsToShow, expanded = false;
    if(this.state.itemsToShow < listLength) {     
      let count = (listLength - this.state.itemsToShow < 10 ) ? (listLength - this.state.itemsToShow) : (listLength );
      itemsToShow = this.state.itemsToShow + count;
      expanded = (itemsToShow < listLength) ? false : true;
    } else {
      itemsToShow = 10;
      expanded = false;
    }
    this.setState({ itemsToShow: itemsToShow , expanded: expanded})
  }
  /**
  * @desc shows/hides additional candidates list 
  * @param CandidateId
  * @return null
  */

  handleCandidateView = (CandidateId,jobTitleId) => {
    this.props.onViewCandidate(CandidateId,jobTitleId);
    //this.props.onSelectCandidate(CandidateId, jobTitleId);
    this.setState({ viewClicked: true});
    window.scrollTo(0,0);
  }

  handleViewClick = () => {
    this.setState({ viewClicked: true});
  }

  handleJobSelected(jobId) {
    const jobList = [...this.props.jobs];
    if(jobList.length > 0 && jobList.find((job) => job.job_id == jobId)) {
      const job =jobList.find((job) => job.job_id == jobId);
      const jobTitle = job.job_name;
      const jobBHID = job.job_bh_id;
      const companyType = job.company_type;
      this.props.onSetJobTitles(jobId, jobTitle, jobBHID, companyType);
    }
  }

  handleCsvDownload = () => {
    let rows = [["Job Title", "Job ID", "Candidate Name","ID", "Current Job", scoringCriteria.default.scoringData.map(criteria => criteria.name), "Total Score", "Status"]];
    const candidatePool = [...this.props.pool];
    if(candidatePool.filter((candidate) => candidate.candidate_status === "PROGRESS").length > 0) {
      const progressedCandidates = (candidatePool.filter((candidate) => candidate.candidate_status === "PROGRESS")
        .map((candidate) => [
          this.props.jobTitle,
          this.props.jobTitleBHID,
          candidate.candidate_fname + " " + candidate.candidate_lname,
          candidate.candidate_source_id,
          (candidate.current_job_title) ? candidate.current_job_title : "None",
          JSON.parse(candidate.candidate_scoring).map((score) => score.value),
          candidate.candidate_score,
          candidate.candidate_status
        ]));
        
      rows = rows.concat(progressedCandidates);
    }

    let csvContent = "data:text/csv;charset=utf-8,";
    rows.forEach(function(rowArray){
      let row = rowArray.join(",");
      csvContent += row + "\r\n";
    }); 

    const encodedUri = encodeURI(csvContent);
    let link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", this.props.jobTitle.replace(/\b\w/g, l => l.toUpperCase()) + " - " + this.props.jobTitleBHID + ".csv");
    document.body.appendChild(link); // Required for FF

    link.click(); // This will download the data file named "my_data.csv".
  }

  handleCloseNotification = () => {
    localStorage.setItem('showNotification', false);
    this.setState({showNotification: false});
  }

  /**
  * @desc actual rendering of the dom element for the component
  * @param null
  * @return DOM element
  */
  render() {
    const slickSettings = {
      dots: false,
      infinite: true,
      centerMode: true,
      centerPadding: '3%',
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    let candidatesData = this.props.pool;
    let emptypoolMessage = "";
    if(!candidatesData || candidatesData.length === 0) {      
      return (null);
    }

   // Handling the situation when the given limit is higher than the total list length:STARTS
    const itemCount = (this.state.itemsToShow > candidatesData.length) ? candidatesData.length : this.state.itemsToShow;
    // Handling the situation when the given limit is higher than the total list length:ENDS

    let resultsOrd = {};
    let results = _.groupBy(candidatesData, 'published_dt');
    const dateArr = Object.keys(results).sort().map(function(i) {
      resultsOrd[i] = results[i];
    });    
    delete(resultsOrd[Object.keys(resultsOrd)[0]]);

    Object.keys(resultsOrd).map((item) => {
      Object.keys(resultsOrd[item]).map((val) => {
        if(resultsOrd[item][val].review_status == "SENT") {
          _.find(candidatesData, (x) => {
            if(x.candidate_id == resultsOrd[item][val].candidate_id) {
              x.isNewlyAddedCandidate = true;
            }
          });
        }
      });
    });
  //   const isNewlyAddedCandidate = (candidatesData.filter(candidate => candidate.review_status === "SENT").length > 0 && candidatesData.filter(candidate => candidate.review_status !== "SENT").length > 0) ? true : false;
  
    const companyType=this.props.companyType;
    return (
      <div className="pool">      
      {this.state.loading?<Loader/>:""}
      {/* <MediaQuery query="(min-device-width: 768px)">
        {this.state.showNotification && localStorage.getItem('showNotification') === 'true'?<ProgreesNotification handleCloseNotification={this.handleCloseNotification}/>:""}
      </MediaQuery> */}
      <div className="client-top-section">
        <MainJobTitle 
          titleClass={"pool-title "} 
          className={"main-job-head"} 
          user_id={ this.props.clientDetails.user_id }
          currentPage="talentPool"
          handleJobSelected={this.handleJobSelected.bind(this)}
        />
        {/* Desktop View CSV Export Section starts */}
        {companyType===1?<MediaQuery query="(min-device-width: 768px)">
          <div className={"cli-csv-export-div" }>
            <Button className="cli-csv-export-button " onClick={this.handleCsvDownload}>
              Export CSV
              <img src={CsvIcon} />
            </Button>
          </div>
        </MediaQuery>:""}
        {/* Desktop View CSV Export Section Ends */}
      </div>
        {/* Mobile View Section starts */}  
        {!this.props.pool[0].message  ?      
        <MediaQuery query="(max-device-width: 769px)">       
          <div className="reviewAllButtonSection">
            <LinkContainer className="reviewAllButton" to={'/talentpool/review'}>
              <button className="reviewAllButtonText">Review all</button>
            </LinkContainer>
          </div>
          <Slider {...slickSettings} className={(candidatesData.length === 1) ? "single-slider-card" : ""}>      
            {candidatesData.map((candidate, index) => (             
              <CandidateCard 
                count={index} 
                candidateLength={candidatesData.length} 
                handleCandidateSelect={() => this.handleCandidateView(candidate.candidate_id,this.props.jobTitleId)} 
                activeCandidateId={this.props.activeCandidateId} 
                id={candidate.candidate_id} 
                poolStatus={candidate.candidate_status} 
                reviewStatus={candidate.review_status}
                key={index}
                dateArr={dateArr}
                {...candidate}
                isNewlyAddedCandidate={candidate.isNewlyAddedCandidate}
              />
            ))}			
          </Slider>
        </MediaQuery>:null}
        {/* Mobile View Section ends */}

        {/* Desktop View Section starts */}
        {!this.props.pool[0].message  ?
        <MediaQuery query="(min-device-width: 768px)">
          <div ref="pool">       
          <Row className="show-grid">
            <Col xs={12} md={3} className="pool-card-list">
              <div className="reviewAllButtonSection">
                <LinkContainer className="reviewAllButton" to={'/talentpool/review'}>
                  <button className="reviewAllButtonText">Review all</button>
                </LinkContainer>
                <span className="pagination-text">
                  Displaying {itemCount} of {candidatesData.length}
                </span>               
              </div>         
              {candidatesData.slice(0, this.state.itemsToShow ).map((candidate, index) => (               
                <CandidateCard 
                  handleCandidateSelect={() => this.handleCandidateView(candidate.candidate_id,this.props.jobTitleId)} 
                  activeCandidateId={this.props.activeCandidateId} 
                  id={candidate.candidate_id} 
                  poolStatus={candidate.candidate_status} 
                  reviewStatus={candidate.review_status}
                  key={index} 
                  {...candidate} 
                  dateArr={dateArr}
                  isNewlyAddedCandidate={candidate.isNewlyAddedCandidate}/>
              ))}   
              {/* Show-more/less button starts */}
              {this.state.itemsToShow >=candidatesData.length ? 
                (this.state.expanded ? <div className="show-btn"><button className="show-more" onClick={() => this.showMore(candidatesData)}>                             
                  <span>Show less <img src={showMoreBtn} className="up-arrow"/></span>
                  </button></div>
                : null )
              :
                <div className="show-btn"><button className="show-more" onClick={() => this.showMore(candidatesData)}>
                  { this.state.expanded ? (
                    <span>Show less <img src={showMoreBtn}
                      className="up-arrow"/></span>
                    ) : (
                      <span>Show {(candidatesData.length - this.state.itemsToShow < 10 ) ? (candidatesData.length - this.state.itemsToShow) :(candidatesData.length - this.state.itemsToShow) } more <img src={showMoreBtn}
                      className="down-arrow"/></span>
                    )
                  }
                </button></div>
              }
            </Col>

            <Col xs={12} md={9} className="profile-wrapper">
              <Profile 
              viewClicked={this.state.viewClicked}
              handleViewClick={this.handleViewClick}
              jobChanged={this.props.jobTitleId}
              />
            </Col>            
          </Row>
          </div>
        </MediaQuery>:null}
        {/* Desktop View Section ends */}
	  	</div>
    );
  }
}

const foundInPool = (activeCandidateId, pool) => {
  return pool.find(candidate => candidate.candidate_id === activeCandidateId)
}

/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
  return {
      pool: state.talentPool.pool,
      activeCandidateId: state.talentPool.activeCandidateId,
      jobTitleId :state.talentPool.jobTitleId,
      profileInfo: state.candidateProfile.profileInfo,
      jobs: state.talentPool.jobList,
      user:state.cognito.user,
      clientDetails: state.clientProfile.clientDetails,
      companyType:state.talentPool.companyType,      
      jobTitle: state.talentPool.jobTitle,
      jobTitleBHID: state.talentPool.jobTitleBHID,
      showProgressNotification: state.talentPool.showProgressNotification,
      interviewExists: state.talentPool.interviewExists
  };
}

/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/

const mapDispatchToProps = dispatch => {
  return {
    onGetTalentPool: (jobTitleId,user) => dispatch(actions.getTalentPool(jobTitleId,user)),
    onViewCandidate: (canidateId,jobTitleId) => dispatch(actions.viewCandidate(canidateId,jobTitleId)),
    onGetProfileDetails: (canidateId, jobTitleId,isClient,user) => dispatch(actions.getProfileDetails(canidateId, jobTitleId,isClient,user)),
    onSelectCandidate: (canidateId, jobTitleId,isClient) => dispatch(actions.getProfileDetails(canidateId, jobTitleId,isClient=true)),
    onSetJobTitles: (jobTitleId, jobTitle, jobBHID, companyType) => dispatch(actions.setJobTitle(jobTitleId,jobTitle, jobBHID, companyType)),
    onProgressing: (status) => dispatch(actions.setProgressNotification(status)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(withRouter(TalentPool),axios));





// WEBPACK FOOTER //
// ./src/container/Client/TalentPool/TalentPool.js